/* Toasts: bottom right, 360px at most, the popover shadow. Enter 200ms (translateY(8px) and fade), exit
   140ms. Only transform and opacity move. Colour comes from the status tokens already measured. */
.region {
  position: fixed;
  right: var(--pad);
  bottom: var(--pad);
  z-index: 60;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: min(360px, calc(100vw - 2 * var(--pad)));
  pointer-events: none;
}

.toast {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 10px 12px;
  border: 1px solid var(--line-2);
  border-radius: var(--radius-card);
  background: var(--panel);
  color: var(--ink);
  font-size: var(--t-dense);
  line-height: var(--lh-13);
  box-shadow: var(--shadow-pop);
  pointer-events: auto;
  animation: toast-in 200ms var(--ease-out) both;
}

.success {
  border-color: var(--ok-line);
  background: var(--ok-w);
}

.error {
  border-color: var(--crit-line);
  background: var(--crit-w);
}

.info {
  border-color: var(--info-line);
  background: var(--info-w);
}

.leaving {
  animation: toast-out 140ms var(--ease-exit) both;
}

.message {
  flex: 1;
  min-width: 0;
  overflow-wrap: anywhere;
}

.close {
  flex: 0 0 auto;
  display: inline-grid;
  place-items: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border: 0;
  border-radius: var(--radius-ctl);
  background: transparent;
  color: var(--muted);
  cursor: pointer;
}

.close:hover {
  color: var(--ink);
}

.close:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 1px;
}

@keyframes toast-in {
  from {
    opacity: 0;
    transform: translateY(8px);
  }

  to {
    opacity: 1;
    transform: none;
  }
}

@keyframes toast-out {
  from {
    opacity: 1;
    transform: none;
  }

  to {
    opacity: 0;
    transform: translateY(8px);
  }
}

@media (prefers-reduced-motion: reduce) {
  .toast,
  .leaving {
    animation: none;
  }
}
